import React, { useState } from 'react';
import { Box, Typography, Button, CircularProgress, Alert, Container } from '@mui/material';
import COLORS from '../../../../constants/colors';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Header from './Header';
import baseURL from '../config';

const VerifyEmailPage = () => {
  const [status, setStatus] = useState('idle'); // 'idle', 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');

  const handleVerifyClick = async () => {
    if (!token) {
      setStatus('error');
      setMessage('Verification token is missing.');
      return;
    }

    setStatus('verifying');
    setMessage('Verifying your email, please wait...');

    try {
      const response = await fetch(`${baseURL}/auth/user/verify-email?token=${token}`);
      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage(data.message || 'Your email has been successfully verified!');
      } else {
        setStatus('error');
        setMessage(data.message || 'Failed to verify your email. Please try again or contact support.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('An error occurred while verifying your email. Please check your internet connection and try again.');
    }
  };

  return (
    <>
      <Header />

      <Box
        sx={{
          minHeight: '90vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          px: 2,
          bgcolor: COLORS.background || '#f9f9f9',
        }}
      >
        <Container maxWidth="sm">
          <Box
            sx={{
              bgcolor: COLORS.white,
              boxShadow: 0,
              borderRadius: 3,
              p: 4,
              textAlign: 'center',
              maxWidth: 500,
              mx: 'auto',
            }}
          >
            <Typography
              variant="h4"
              fontWeight="bold"
              color={COLORS.primary}
              mb={1}
              sx={{ fontSize: { xs: '1.6rem', sm: '2rem' } }}
            >
              Email Verification
            </Typography>
            <Typography
              variant="body1"
              color={COLORS.text}
              mb={3}
              sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}
            >
              Thank you for signing up! Verifying your email helps us keep your account secure and ensures you receive important notifications.
            </Typography>

            {status === 'idle' && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleVerifyClick}
                sx={{
                  borderRadius: '10px',
                  py: 1,
                  fontSize: '0.9rem',
                  textTransform: 'none',
                  minWidth: 140,
                }}
              >
                Verify Email
              </Button>
            )}

            {status === 'verifying' && (
              <>
                <CircularProgress color="primary" size={24} />
                <Typography variant="body1" color={COLORS.text} mt={2}>
                  {message}
                </Typography>
              </>
            )}

            {(status === 'success' || status === 'error') && (
              <>
                <Alert severity={status === 'success' ? 'success' : 'error'} sx={{ mb: 3, fontSize: '1rem' }}>
                  {message}
                </Alert>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/user/login')}
                  sx={{
                    backgroundColor: COLORS.primary,
                    color: COLORS.white,
                    borderRadius: '10px',
                    py: 1,
                    fontSize: '0.8rem',
                    textTransform: 'none',
                    minWidth: 140,
                  }}
                >
                  Proceed to Login
                </Button>
              </>
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default VerifyEmailPage;
